DialogController = App.loadClass 'core::Angular/DialogController'

class exports.ViewAccountInfoController extends DialogController

    constructor: (@scope, @transitions, @modal, @modalInstance, @service, account) ->
        super(@scope, @transitions, @modalInstance)
        @scope.editCompanies = @editCompanies

        if account.data.status.type is 'success'
            @scope.account = account.data.data
        else
            @scope.no_user_message = account.data.status.msg


    editCompanies: () =>
        newscope = @scope.$new(true)
        newscope.user = @scope.user
        dlg = @modal.open
            scope: newscope
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/new-tools/manage-users/edit-companies-layout'
            controller: 'Tools.Controllers.EditCompaniesController'
            resolve:
                'associations': ['Tools.Services.ManageUsersService', (service) =>
                    return service.getUserCompanies(@scope.user.id)
                ]

        dlg.result.then () =>
            @service.viewAccountInfo(@scope.user.id).then (response) =>
                if response.data.status.type is 'success'
                    @scope.account = response.data.data

